import React from 'react';
import styled from 'styled-components';

const TagWrapper = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 4px;
  margin-right: 8px;
  font-weight: 500;
  background-color: ${(props) => {
    switch (props.color) {
      case 'success':
        return '#52c41a1a';
      case 'warning':
        return '#faad141a';
      case 'error':
        return '#ff4d4f1a';
      case 'blue':
        return '#1890ff1a';
      case 'default':
        return '#d9d9d9';
      default:
        return props.color ? `${props.color}1a` : '#d9d9d9';
    }
  }};
  color: ${(props) => {
    switch (props.color) {
      case 'success':
        return '#52c41a';
      case 'warning':
        return '#faad14';
      case 'error':
        return '#ff4d4f';
      case 'blue':
        return '#1890ff';
      case 'default':
        return '#666666';
      default:
        return props.color || '#666666';
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.color) {
        case 'success':
          return '#52c41a';
        case 'warning':
          return '#faad14';
        case 'error':
          return '#ff4d4f';
        case 'blue':
          return '#1890ff';
        case 'default':
          return '#d9d9d9';
        default:
          return props.color || '#d9d9d9';
      }
    }};
`;

function CustomTag({ color, children, ...rest }) {
  return (
    <TagWrapper color={color} {...rest}>
      {children}
    </TagWrapper>
  );
}

export default CustomTag;
